import React from 'react';

import { ListRow, Text } from '@betterment/samba-react';
import { SystemStyleObject } from '@betterment/samba-styled-system/types';

import { formatContributionValue } from './payrollContributionUtils';

import { PayrollContributionConfigFragment } from '../../../graphql/fragments/payrollContributionConfig.generated';

type Props = {
  config: PayrollContributionConfigFragment;
  css?: SystemStyleObject;
};

export const BonusPayrollContributionRow: React.FC<Props> = ({ config }) => {
  const bonusText = formatContributionValue(config.bonusValue, config.destinationName);

  return (
    <ListRow key={`${config.id}-bonus`} css={{ padding: 'space.0', alignItems: 'start' }}>
      <ListRow.LeadingContent>
        <Text>{bonusText}</Text>
      </ListRow.LeadingContent>
    </ListRow>
  );
};
